// 单选类型的HeaderCell
import { HeaderFieldCellMixins } from './mixins.js';

const _Option = Vue.extend({
  mixins: [HeaderFieldCellMixins],

  data: function() {
    return {
      options: [],
      activeOption: null
    };
  },

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container list">
        <div class="list-item"
             v-for='option in options'
             :key='option.id'
             @click="toggleOption(option)">
          <div class="content">{{ option.value }}</div>
          <div class="tip" v-if="activeOption == option">
            <i class="slp-check"></i>
          </div>
        </div>
      </div>
    </div>
  `,

  methods: {
    toggleOption: function(option) {
      if (this.activeOption === option) {
        return;
      }
      this.activeOption = option;
      this.$emit('filterChanged', false);
    },

    getFilter: function() {
      return this.activeOption;
    },

    resetFilter: function() {
      this.activeOption = this.filter?.value;
    }
  }
});

const YAW__AssignmentDurationThresholdHeaderCell = Vue.extend({
  extends: _Option,

  data: function() {
    return {
      options: [
        { id: 'unoverdued', value: '未逾期' },
        { id: 'overdued', value: '逾期' }
      ]
    };
  }
});

export { YAW__AssignmentDurationThresholdHeaderCell };
